/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const SET_FETCH_FACILITY_IMAGES_STATUS = 'SET_FETCH_FACILITY_IMAGES_STATUS';
export const FETCH_FACILITY_IMAGES_SUCCESS = 'FETCH_FACILITY_IMAGES_SUCCESS';
export const FETCH_FACILITY_IMAGES_ERROR = 'FETCH_FACILITY_IMAGES_ERROR';

export function fetchFacilityImagesSuccess(data) {
    return {
        type: FETCH_FACILITY_IMAGES_SUCCESS,
        payload: data,
    };
}

export function fetchFacilityImagesError(error) {
    return {
        type: FETCH_FACILITY_IMAGES_ERROR,
        payload: error,
    };
}

export function setFetchFacilityImagesStatus(status) {
    return {
        type: SET_FETCH_FACILITY_IMAGES_STATUS,
        payload: status,
    };
}
